import React from 'react';
import { ProgressBar } from 'react-bootstrap';

export default function CustomProgressBar({ progress = 0 }) {
  const getVariant = (progress) => {
    if (progress < 30) return 'danger';
    if (progress < 70) return 'warning';
    return 'success';
  };

  const getStripes = (progress) => {
    return progress < 100; // Rayas animadas hasta completar
  };

  return (
    <div className="py-2 px-3">
      <div className="position-relative">
        <ProgressBar 
          now={progress} 
          variant={getVariant(progress)}
          striped={getStripes(progress)}
          animated={getStripes(progress)}
          style={{ height: '30px' }}
        />
        <div 
          className="position-absolute top-50 start-50 translate-middle"
          style={{ 
            fontWeight: 'bold', 
            fontSize: '14px',
            color: progress > 50 ? 'white' : '#333',
            textShadow: progress > 50 ? '1px 1px 2px rgba(0,0,0,0.7)' : '1px 1px 2px rgba(255,255,255,0.7)',
            zIndex: 2
          }}
        >
          {progress.toFixed(1)}%
        </div>
      </div>
    </div>
  );
}
